<h2 mat-dialog-title>{{ 'waters.ratings.edit-title' | translate }}</h2>
<mat-dialog-content>
  <p class="text-sm text-gray-500 pt-2">
    {{ 'waters.ratings.field.locale' | translate }}: {{ rating.locale ? (rating.locale | uppercase) : '—' }}
  </p>
  <form [formGroup]="form" class="flex flex-col gap-4 pt-2">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <mat-form-field>
        <mat-label>{{ 'waters.ratings.field.name' | translate }}</mat-label>
        <input matInput formControlName="name" maxlength="255" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'waters.ratings.field.email' | translate }}</mat-label>
        <input matInput type="email" formControlName="email" maxlength="255" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'waters.ratings.field.amountOfFishermen' | translate }}</mat-label>
        <input matInput type="number" formControlName="amountOfFishermen" min="1" />
        @if (form.controls.amountOfFishermen.hasError('min')) {
          <mat-error>{{ 'waters.ratings.amountOfFishermen-min' | translate }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'waters.ratings.field.arrivalDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="arrivalDate" />
        <mat-datepicker-toggle matIconSuffix [for]="picker" />
        <mat-datepicker #picker />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'waters.ratings.field.type' | translate }}</mat-label>
        <mat-select formControlName="type">
          <mat-option [value]="null">{{ 'generic.none' | translate }}</mat-option>
          @for (option of typeOptions; track option) {
            <mat-option [value]="option">{{ 'waters.ratings.type.' + option | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="flex flex-col gap-1">
        <label class="text-sm text-gray-600">
          {{ 'waters.ratings.field.companyReview' | translate }}: {{ form.controls.companyReview.value }} / 10
        </label>
        <mat-slider min="1" max="10" step="1" discrete class="w-full">
          <input matSliderThumb formControlName="companyReview" />
        </mat-slider>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm text-gray-600">
          {{ 'waters.ratings.field.waterReview' | translate }}: {{ form.controls.waterReview.value }} / 10
        </label>
        <mat-slider min="1" max="10" step="1" discrete class="w-full">
          <input matSliderThumb formControlName="waterReview" />
        </mat-slider>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm text-gray-600">
          {{ 'waters.ratings.field.waterSideGuidanceReview' | translate }}: {{ form.controls.waterSideGuidanceReview.value }} / 10
        </label>
        <mat-slider min="1" max="10" step="1" discrete class="w-full">
          <input matSliderThumb formControlName="waterSideGuidanceReview" />
        </mat-slider>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm text-gray-600">
          {{ 'waters.ratings.field.facilitiesReview' | translate }}: {{ form.controls.facilitiesReview.value }} / 10
        </label>
        <mat-slider min="1" max="10" step="1" discrete class="w-full">
          <input matSliderThumb formControlName="facilitiesReview" />
        </mat-slider>
      </div>
    </div>

    <mat-form-field>
      <mat-label>{{ 'waters.ratings.field.catches' | translate }}</mat-label>
      <textarea matInput formControlName="catches" rows="2"></textarea>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'waters.ratings.field.tips' | translate }}</mat-label>
      <textarea matInput formControlName="tips" rows="2"></textarea>
    </mat-form-field>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <mat-form-field>
        <mat-label>{{ 'waters.ratings.field.pros' | translate }}</mat-label>
        <mat-chip-grid #prosGrid>
          @for (pro of pros(); track $index) {
            <mat-chip-row (removed)="removePro($index)">
              {{ pro }}
              <button matChipRemove [attr.aria-label]="'waters.form.delete' | translate">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          [matChipInputFor]="prosGrid"
          [matChipInputAddOnBlur]="true"
          [disabled]="pros().length >= maxListItems"
          (matChipInputTokenEnd)="addPro($event)"
        />
        <mat-hint>{{ 'waters.ratings.list-hint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'waters.ratings.field.cons' | translate }}</mat-label>
        <mat-chip-grid #consGrid>
          @for (con of cons(); track $index) {
            <mat-chip-row (removed)="removeCon($index)">
              {{ con }}
              <button matChipRemove [attr.aria-label]="'waters.form.delete' | translate">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          [matChipInputFor]="consGrid"
          [matChipInputAddOnBlur]="true"
          [disabled]="cons().length >= maxListItems"
          (matChipInputTokenEnd)="addCon($event)"
        />
        <mat-hint>{{ 'waters.ratings.list-hint' | translate }}</mat-hint>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">{{ 'waters.form.cancel' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="save()">
    {{ 'waters.form.save' | translate }}
  </button>
</mat-dialog-actions>
